import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./InputX.css";

const InputX = ({ onClick }) => {
  return <CloseIcon className={"inputX"} onClick={onClick} />;
};

export default InputX;
